// extracted by mini-css-extract-plugin
export default {"Cards":"Card_Cards__LydxK"};